<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 5%">
                            <div class="text-center">
                                <br /><br /><br />
                                <h1 class="custom-text-aladdin text-black poppin-font text-48px">
                                    How It Works
                                </h1>
                                <p class="custom-16px-400 text-center ml-4">Get to know the talented individuals driving our company forward.</p>
    
                                <br /><br /><br />
                                <CContainer>
                                <CRow>
                                    <CCol sm="4">
                                        <CCard class="bg-white b-20 p-20" style="border:none">
                                            <img src="../assets/img/iconcamera.png" style="width:30px" class="m-4" />
                                            <h3 class="custom-24px-500 text-left ml-4">
                                                Upload
                                            </h3>
                                            <p class="custom-16px-400 text-left ml-4">
                                                Self-recording to answer instant questions on the Interviewrr portal and get expert feedback through the email/portal.</p>
                                        </CCard>
                                    </CCol>
                                    <CCol sm="4">
                                        <CCard class="bg-white b-20 p-20" style="border:none">
                                            <img src="../assets/img/iconai.png" style="width:30px" class="m-4" />
                                            <h3 class="custom-24px-500 text-left ml-4">
                                                AI Review
                                            </h3>
                                            <p class="custom-16px-400 text-left ml-4">
                                                Our AI-powered platform offers top-notch feedback,<br /> along with exclusive insights<br /> from industry experts. </p>
                                        </CCard>
                                    </CCol>
                                    <CCol sm="4">
                                        <CCard class="bg-white b-20 p-20" style="border:none">
                                            <img src="../assets/img/iconrefine.png" style="width:30px" class="m-4" />
                                            <h3 class="custom-24px-500 text-left ml-4">
                                                Refinement
                                            </h3>
                                            <p class="custom-16px-400 text-left ml-4">
                                                Tailored feedback to enhance user resume <br />and increase their chances <br /> of landing a job.</p>
                                        </CCard>
                                    </CCol>
                                </CRow>
                            </CContainer>
                            </div>
    
    
    
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12">
            <CContainer>
                <CRow>
                    <CCol sm="12">
                        <h3 class="custom-30px-600 mt-4">Interview Question</h3>
                    </CCol>
                    <CCol sm="6">
                        <label class="custom-20px-500">1.  Tell me about yourself?</label>
                    </CCol>
                    <CCol sm="6">
                        <div class="text-right">
                            <span class="custom-border-purple p-2" style="width:120px" @click="OpenPopup()"><span class="ml-5 mr-5">Next</span></span>
                        </div>
                    </CCol>
                    <CCol sm="12">
                        <img src="../assets/img/videointerview.png" style="max-width:100%"/>
                    </CCol>
                    <CCol sm="12">
                        <label class="custom-14px-500 mt-4">
                            Or Upload from URL
                        </label>
                        <CRow>
                            <CCol sm="10">
                                <input type="text" class="custom-input-app" />
                            </CCol>
                            <CCol sm="2">
                                <CButton type="button" class="custom-border-purple-615FCD font-color-615FCD">Upload</CButton>
                            </CCol>
                            <CCol sm="1">
<img src="../assets/img/iconfile.png" style="max-width:100%" class="mt-3"/>
                            </CCol>
                            <CCol sm="11">
                                <p class="custom-14px-500 mt-2">interview.mp4</p>
                                <p class="custom-14px-400">200 KB – 70% uploaded</p>

</CCol>
<CCol sm="12">
    <h4 class="custom-20px-700 mt-4">
        Tips For Answer
    </h4>
    <p class="custom-18px-500 font-color-171717">Please respond to the question based on your understanding of the subject, recording yourself using your computer's camera within the allocated time. Ensure you have good lighting, minimal background noise, and aim for a high-quality recording to enhance your presentation.</p>
</CCol>
                        </CRow>
                       
                    </CCol>
                </CRow>
            </CContainer>
        </CCol>

        <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                Sign up now for free and take the first step toward landing your dream job!
                                                                </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>

        <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/mail.png" />
                    <h3 class="custom-18px text-center">Your results will be sent immediately via email </h3>
                </div>
                <CButton class="button-border-202020" @click="closePopup" block><span class="ml-2 mr-2">Close</span></CButton>
            </div>
        </div>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow,
            isLanguagePopupVisible: false,


        };
    },
    created() {
        AOS.init();
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        OpenPopup() {
            // Show the popup and backdrop
            this.isLanguagePopupVisible = true;
        },
        closePopup() {
            this.isLanguagePopupVisible = false;
            this.$router.push("Result");
        },
    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>